import { single_mosfet } from './single_mosfet';

import { ID_GRAPH_AXIS } from '../../constants/idDefinition';
import { CHART_TYPE, SIMULATION_TYPE, UNITS_SIGN } from '../../constants/definitionConstants';

export class nvnjws200n031ltag extends single_mosfet {
	constructor(opn) {
		super(opn, 'nvnjws200n031l');
		this.PACKAGE_IMAGE = require(`../../images/XDFNW3_CASE_521AC.png`);
		this.modelLink = `https://www.${this.domain}/download/models/lib/nvnjws200n031l.lib`;
		this.netlist2pls = `resources/${this.wpn}/${this.opn}/netlists/${this.opn}_Two_Pulse.txt`;
		this.SCHEMATIC_2PLS = require(`../../images/${this.opn}_SCH_Two_Pulse.svg`);
	}

	gainDefinition() {
		const TWO_PULSE_CHART_COLUMN_MAPPING = {
			TIME: 0,
			TEMP: 1,
			V_BUS: 2,
			V_GEN: 3,
			V_BASE: 4,
			I_DRAIN: 5,
			V_DS: 6,
			I_LOAD: 7,
			P_TRL: 8
		};
		const customizations = {
			simulations: [
				{
					netlist: {
						displayNetlist: true
					},
					inputParameters: [
						{
							/**
							 * base heading (heading is created from heading + unit)
							 */
							heading: 'V<sub>GS<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							/**
							 * if unit is not base unit but for example it is in kilo ohm it is needed
							 * to add extension for simulator which tells that it is kilo that’s mean ‘k’
							 */
							netlistUnit: '',
							/**
							 * exact name of parameter from netlist to be replaced
							 */
							mappingName: 'VgsMin',
							minBoundary: 0.1,
							maxBoundary: 15,
							defaultValue: 1.5
						},
						{
							heading: 'V<sub>GS<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsMax',
							minBoundary: 0.2,
							maxBoundary: 8,
							defaultValue: 5
						},
						{
							heading: 'V<sub>GS<sub>(increment)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsStep',
							minBoundary: 0.1,
							maxBoundary: 5,
							defaultValue: 0.25
						},
						{
							heading: 'V<sub>D<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VdMin',
							minBoundary: 0.1,
							maxBoundary: 40,
							defaultValue: 0.1
						},
						{
							heading: 'V<sub>D<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VdMax',
							minBoundary: 1,
							maxBoundary: 50,
							defaultValue: 5
						},
						{
							heading: 'V<sub>D<sub>(increment)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VdStep',
							minBoundary: 0.1,
							maxBoundary: 5,
							defaultValue: 0.25
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -40,
							maxBoundary: 150,
							defaultValue: 25,
							displayInput: true
						}
					]
				},
				{
					heading: 'Two Pulse Test',
					showRawData: false,
					inputHeading: 'Input parameters',
					showInputParams: false,
					note: 'Results are linearly decimated based on t<sub>step<sub>max</sub></sub> parameter.',

					inputParameters: [
						{
							heading: 'V<sub>BUS<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VbusMax',
							minBoundary: 1,
							maxBoundary: 20,
							defaultValue: 15
						},
						{
							heading: 'V<sub>BUS<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VbusMin',
							minBoundary: 1,
							maxBoundary: 18,
							defaultValue: 12
						},
						{
							heading: 'V<sub>BUS<sub>(step)</sub></sub>',
							unit: UNITS_SIGN.NOUNITS,
							netlistUnit: '',
							mappingName: 'nVbusStep',
							minBoundary: 1,
							maxBoundary: 8,
							defaultValue: 2,
							isInteger: true
						},
						{
							heading: 'C<sub>BUS</sub>',
							unit: UNITS_SIGN.MICRO_FARAD,
							netlistUnit: 'u',
							mappingName: 'BusCap',
							minBoundary: 0.1,
							maxBoundary: 1000,
							defaultValue: 10
						},
						{
							heading: 't<sub>step<sub>max</sub></sub>',
							unit: UNITS_SIGN.MICRO_SECOND,
							netlistUnit: 'u',
							mappingName: 'TstepMax',
							minBoundary: 0.1,
							maxBoundary: 20,
							defaultValue: 2.5
						},
						{
							heading: 'V<sub>GEN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgenMax',
							minBoundary: 0,
							maxBoundary: 8,
							defaultValue: 6
						},
						{
							heading: 'V<sub>GEN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgenMin',
							minBoundary: -2,
							maxBoundary: 7.5,
							defaultValue: 0
						},
						{
							heading: 't<sub>delay</sub>',
							unit: UNITS_SIGN.MICRO_SECOND,
							netlistUnit: 'u',
							mappingName: 'VgenDelay',
							minBoundary: 1,
							maxBoundary: 100,
							defaultValue: 20
						},
						{
							heading: 't<sub>rise</sub>',
							unit: UNITS_SIGN.MICRO_SECOND,
							netlistUnit: 'u',
							mappingName: 'VgenTr',
							minBoundary: 0.1,
							maxBoundary: 100,
							defaultValue: 1
						},
						{
							heading: 't<sub>fall</sub>',
							unit: UNITS_SIGN.MICRO_SECOND,
							netlistUnit: 'u',
							mappingName: 'VgenTf',
							minBoundary: 0.1,
							maxBoundary: 100,
							defaultValue: 1
						},
						{
							heading: 't<sub>ON</sub>',
							unit: UNITS_SIGN.MICRO_SECOND,
							netlistUnit: 'u',
							mappingName: 'VgenTon',
							minBoundary: 1,
							maxBoundary: 200,
							defaultValue: 100
						},
						{
							heading: 't<sub>OFF</sub>',
							unit: UNITS_SIGN.MICRO_SECOND,
							netlistUnit: 'u',
							mappingName: 'VgenToff',
							minBoundary: 1,
							maxBoundary: 100,
							defaultValue: 30
						},
						{
							heading: 'L<sub>LOAD</sub>',
							unit: UNITS_SIGN.MICRO_HENRY,
							netlistUnit: 'u',
							mappingName: 'Lload',
							minBoundary: 500,
							maxBoundary: 1000,
							defaultValue: 700
						},
						{
							heading: 'R<sub>LOAD</sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'Rload',
							minBoundary: 0.1,
							maxBoundary: 10000,
							defaultValue: 100
						},
						{
							heading: 'R<sub>GEN</sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'Rgen',
							minBoundary: 0.1,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'R<sub>DRAIN<sub>H</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'RdH',
							minBoundary: 0.1,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'L<sub>DRAIN<sub>H</sub></sub>',
							unit: UNITS_SIGN.NANO_HENRY,
							netlistUnit: 'n',
							mappingName: 'LdH',
							minBoundary: 1,
							maxBoundary: 10000,
							defaultValue: 1
						},
						{
							heading: 'R<sub>GATE<sub>H</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'RgH',
							minBoundary: 0.1,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'L<sub>GATE<sub>H</sub></sub>',
							unit: UNITS_SIGN.NANO_HENRY,
							netlistUnit: 'n',
							mappingName: 'LgH',
							minBoundary: 1,
							maxBoundary: 10000,
							defaultValue: 1
						},
						{
							heading: 'R<sub>SOURCE<sub>H</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'RsH',
							minBoundary: 0.1,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'L<sub>SOURCE<sub>H</sub></sub>',
							unit: UNITS_SIGN.NANO_HENRY,
							netlistUnit: 'n',
							mappingName: 'LsH',
							minBoundary: 1,
							maxBoundary: 10000,
							defaultValue: 1
						},
						{
							heading: 'C<sub>DS<sub>H</sub></sub>',
							unit: UNITS_SIGN.PICO_FARAD,
							netlistUnit: 'p',
							mappingName: 'CdsH',
							minBoundary: 0.1,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'R<sub>DRAIN<sub>L</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'RdL',
							minBoundary: 0.1,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'L<sub>DRAIN<sub>L</sub></sub>',
							unit: UNITS_SIGN.NANO_HENRY,
							netlistUnit: 'n',
							mappingName: 'LdL',
							minBoundary: 1,
							maxBoundary: 10000,
							defaultValue: 1
						},
						{
							heading: 'R<sub>GATE<sub>L</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'RgL',
							minBoundary: 0.1,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'L<sub>GATE<sub>L</sub></sub>',
							unit: UNITS_SIGN.NANO_HENRY,
							netlistUnit: 'n',
							mappingName: 'LgL',
							minBoundary: 1,
							maxBoundary: 10000,
							defaultValue: 1
						},
						{
							heading: 'R<sub>SOURCE<sub>L</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'RsL',
							minBoundary: 0.1,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'L<sub>SOURCE<sub>L</sub></sub>',
							unit: UNITS_SIGN.NANO_HENRY,
							netlistUnit: 'n',
							mappingName: 'LsL',
							minBoundary: 1,
							maxBoundary: 10000,
							defaultValue: 1
						},
						{
							heading: 'C<sub>DS<sub>L</sub></sub>',
							unit: UNITS_SIGN.PICO_FARAD,
							netlistUnit: 'p',
							mappingName: 'CdsL',
							minBoundary: 0.1,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'AmbTemp',
							minBoundary: -40,
							maxBoundary: 150,
							defaultValue: 25,
							displayInput: true
						}
					],
					netlist: {
						heading: 'Netlist',
						netlistPath: this.netlist2pls,
						displayNetlist: true
					},
					schematic: {
						heading: 'Application schematic',
						schematicPath: this.SCHEMATIC_2PLS
					},
					charts: [
						{
							id: 'VgenVsTime',
							mainHeading:
								'V[baseline-shift: sub; font-size: 11px;]GEN[/] = f (t,V[baseline-shift: sub;font-size: 11px;]BUS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]GEN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.V_GEN
								}
							],
							series: {
								heading: 'V[baseline-shift: sub;font-size: 11px;]BUS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.V_BUS
							}
						},
						{
							id: 'VqbaseVsTime',
							mainHeading:
								'V[baseline-shift: sub; font-size: 11px;]QBASE[/] = f (t,V[baseline-shift: sub;font-size: 11px;]BUS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]QBASE[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.V_BASE
								}
							],
							series: {
								heading: 'V[baseline-shift: sub;font-size: 11px;]BUS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.V_BUS
							}
						},
						{
							id: 'IdrainVsTime',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]DRAIN[/] = f (t,V[baseline-shift: sub;font-size: 11px;]BUS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]DRAIN[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.I_DRAIN
								}
							],
							series: {
								heading: 'V[baseline-shift: sub;font-size: 11px;]BUS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.V_BUS
							}
						},
						{
							id: 'IloadVsTime',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]LOAD[/] = f (t,V[baseline-shift: sub;font-size: 11px;]BUS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]LOAD[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.I_LOAD
								}
							],
							series: {
								heading: 'V[baseline-shift: sub;font-size: 11px;]BUS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.V_BUS
							}
						},
						{
							id: 'VdsVsTime',
							mainHeading:
								'V[baseline-shift: sub; font-size: 11px;]DS[/] = f (t,V[baseline-shift: sub;font-size: 11px;]BUS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]DS[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.V_DS
								}
							],
							series: {
								heading: 'V[baseline-shift: sub;font-size: 11px;]BUS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.V_BUS
							}
						},
						{
							id: 'PdVsTime',
							mainHeading:
								'P[baseline-shift: sub; font-size: 11px;]XQL[/] = f (t,V[baseline-shift: sub;font-size: 11px;]BUS[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'P[baseline-shift: sub; font-size: 11px;]XQL[/]',
									unit: UNITS_SIGN.WATT,
									columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.P_TRL
								}
							],
							series: {
								heading: 'V[baseline-shift: sub;font-size: 11px;]BUS[/]',
								unit: UNITS_SIGN.VOLT,
								columnNumber: TWO_PULSE_CHART_COLUMN_MAPPING.V_BUS
							}
						}
					]
				}
			]
		};
		return super.gainDefinition(customizations);
	}
}
